import styles from "./styles/AuthLayout.module.css";
import background from "@assets/svgs/sign_background.svg";
import { AuthHeader } from "./AuthHeader";
import { AuthFooter } from "./AuthFooter";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { useLayoutEffect, useState } from "react";
import { useWindowSize } from "@hooks";
import clsx from "clsx";
import { ToastContainer } from "react-toastify";

const AuthLayout = () => {
  // state
  const [bodyClass, setBodyClass] = useState(styles.body);

  // variables
  let spinner = null;
  let spinnerVisible = false;

  // hooks
  const { width: windowWidth } = useWindowSize();
  const {
    emailChecker,
    codeValidator,
    confirmValidator,
    login,
    externalLogin,
    register,
    forgotPassword,
    resetPassword,
  } = useSelector((state) => state.auth);

  // logics
  spinnerVisible =
    emailChecker.processing ||
    codeValidator.processing ||
    confirmValidator.processing ||
    forgotPassword.processing ||
    resetPassword.processing ||
    externalLogin.processing ||
    register.processing ||
    login.processing;

  // UI partials
  if (spinnerVisible)
    spinner = (
      <div className={styles.spinner}>
        <div className="text-center">
          <Spinner animation="border" variant="danger" />
          <div className="text-danger">Processing...</div>
        </div>
      </div>
    );

  // effects
  useLayoutEffect(() => {
    if (windowWidth < 786) setBodyClass(clsx(styles.body, styles.bodySmall));
    else if (windowWidth < 1280)
      setBodyClass(clsx(styles.body, styles.bodyMedium));
    else setBodyClass(styles.body);
  }, [windowWidth]);

  // render
  return (
    <div className={styles.container}>
      <ToastContainer className={styles.toastContainer} />
      <img src={background} alt="background" className={styles.background} />
      <div className={styles.subContainer}>
        <AuthHeader />
        <div className={bodyClass}>
          <Outlet />
          {spinner}
        </div>
        <AuthFooter />
      </div>
    </div>
  );
};

/* required: display name */
AuthLayout.displayName = "AuthLayout";

/* required: props types */
AuthLayout.propTypes = {};

/* required: default props */
AuthLayout.defaultProps = {};

export { AuthLayout };
